import HTTP from "../http";
import Jsona from "jsona";

const dataFormatter = new Jsona();

export default {
  async index(page, sort) {
    try {
      let results = await HTTP.normal.get(
        `/cities?include=districts,state,state.country&page[number]=${page}&sort=${sort}`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar as cidades!";
    }
  },

  async listAll() {
    try {
      let results = await HTTP.normal.get(
        "/cities?include=districts,state,state.country"
      );
      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw "Ocorreu um erro ao listar as cidades!";
    }
  },

  async districts(city_id) {
    try {
      let results = await HTTP.normal.get(
        `/cities/${city_id}/districts?include=rating,pricing`
      );
      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw "Ocorreu um erro ao listar os distritos pela cidade selecionada!";
    }
  },

  async searchByName(query) {
    try {
      let results = await HTTP.normal.get(
        `/cities?filter[display_name]=${query}&filter[active]=true&include=state`
      );

      if (!results.data.data.length)
        throw `A cidade ${query} não foi encontrada!`;

      return dataFormatter.deserialize(results.data)[0];
    } catch (e) {
      throw typeof e === "string"
        ? e
        : "Ocorreu um erro ao buscar as cidades pelo nome!";
    }
  },

  async create(payload) {
    let data = {
      type: "cities",
      display_name: payload.display_name,
      code: payload.code,
      state: {
        type: "states",
        id: payload.state_id
      },
      relationshipNames: ["state"]
    };

    data = dataFormatter.serialize({
      stuff: data
    });

    try {
      await HTTP.normal.post("/cities", data);
    } catch (e) {
      var error = [];

      e.response.data.forEach(el => {
        if (el.title === "has already been taken") {
          error.push({
            field: el.detail.split(" ")[0],
            msg: "já está sendo usado"
          });
        }
      });

      throw error;
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/cities.js